const ApprovalComponent = () => import("@/views/approvals/Approval.vue");
const ApprovalView = () => import("@/views/approvals/ApprovalView.vue");

export default {
  path: "approvals",
  meta: { label: "Approvals" },
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true
      },
      component: ApprovalComponent
    },
    {
      path: "/approvals/View",
      name: "ApprovalView",
      meta: {
        label: "View Approval",
        requiresAuth: true,
      },
      component: ApprovalView
    }
  ]
};
